import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const getFingerprint = async () => {
  const fp = await fpPromise;
  return await fp.get();
};
